import React from 'react'
import { AdminPropertyAd } from 'types'
import { SvgIcon } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ReactComponent as TrashSvg } from 'assets/svg/icons/lists/trash.svg'
import CustomDialog from 'shared/CustomDialog'
import ListService from 'api/services/Lists'
import { PropertyAttributeEnum } from 'types/enums'
import AnalyticsService from 'services/AnalyticsService'

interface Props {
  propertyAd: AdminPropertyAd
  isExpanded: boolean
  onDelete: () => void
  listId: number | null
  listName: string
}
function ListingDelete(props: Props) {
  const { propertyAd, onDelete, listId, listName } = props

  const { t } = useTranslation()

  const deleteFromUserFavoritesList =
    ListService.hooks.useRemoveFromUserFavoritesListMutation({
      onSuccess: () => {
        onDelete()
        AnalyticsService.removeFavorite()
      },
    })

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false)

  const handleOpenDeleteDialog = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpenDeleteDialog(true)
  }
  const handleCloseDeleteDialog = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpenDeleteDialog(false)
  }

  const handleSubmitDelete = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (propertyAd.alternativeId) {
      deleteFromUserFavoritesList.mutate({
        listId: Number(listId),
        propertyAdAlternativeId: propertyAd.alternativeId,
      })
    }
    handleCloseDeleteDialog(e)
  }

  const PROPERTY_TYPE = React.useMemo(() => {
    return propertyAd?.properties?.[0]?.propertyAttributes?.find((item) =>
      [1, 4].includes(propertyAd.adCategory.id)
        ? item.type.description === PropertyAttributeEnum.ESTATE_PROPERTY_TYPE
        : [2, 5].includes(propertyAd.adCategory.id)
        ? item.type.description ===
          PropertyAttributeEnum.ESTATE_PROPERTY_COMMERCIAL_TYPE
        : item.type.description ===
          PropertyAttributeEnum.ESTATE_PROPERTY_LAND_TYPE
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <SvgIcon
        component={TrashSvg}
        inheritViewBox
        onClick={(e) => handleOpenDeleteDialog(e)}
        sx={{
          cursor: 'pointer',
          fill: 'transparent',
          width: { xs: '16px', sm: 24 },
          // height: { xs: 'auto', sm: '33px' },
          height: { xs: '25px', sm: '33px' },
        }}
      />
      <CustomDialog
        open={openDeleteDialog}
        onClose={(e) => handleCloseDeleteDialog(e)}
        onSubmit={(e) => handleSubmitDelete(e)}
        titleLabel={t(`deleteListingPopUp.deleteListingTitle`)}
        subtitleLabel={
          listName !== ''
            ? `${t(
                'deleteListingPopUp.deleteListingMessage'
              )} "${listName}"${';'}`
            : `${t('deleteListingPopUp.deleteListingMessage')} "${t(
                `enums.${PROPERTY_TYPE?.type.description}.${PROPERTY_TYPE?.valueText}.base`
              )} ${
                propertyAd.properties?.[0]?.squareMeters
                  ? t('generics.area', {
                      count: Number(
                        propertyAd?.properties?.[0]?.squareMeters.toFixed(2)
                      ),
                    })
                  : '-'
              }"${';'}`
        }
        cancelLabel={t(`ListPage.deleteDialog.no`)}
        submitLabel={t(`ListPage.deleteDialog.yes`)}
      />
    </>
  )
}

export default ListingDelete
